import { TrackerProps, ButtonType, ButtonActionType } from '@/types/common';
import AgentStore from '@/stores/agent';
import ModalStore from '@/stores/modal';
import {
  TRACKING_OPERATION, TRACKING_PAGE, ChasingStartButtonId, EndChatButtonId,
  ChasingEndButtonId, ChasingButtonClickableStatus, EndChatConfirmType,
} from '@/utils/tracking/constants';

export const PREFIX = 'buttons-container';

export interface IButtons {
  content: string;
  variables?: string;
  disabledBtn?: boolean;
  disabledText: boolean;
  style?: { key: string };
  buttonType?: ButtonType;
  replyMsg?: string;
  actionType?: ButtonActionType;
  url?: any;
  onClick?: () => void;
  clickTracker?: TrackingType;
}

export enum NoticeMsgType {
  Notice = 1,
  ChasingStart = 2,
  ChasingEnd = 3,
}

export enum ShowType {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export interface INoticeProps extends TrackerProps{
  isHistory: boolean;
  type?: NoticeMsgType;
  align?: ShowType;
  passedRef: any;
  disabledBtn: boolean;
  isLastMessage: boolean;
  hasHeader?: boolean;
  title: string;
  variables?: string;
  buttons: IButtons[];
  agentStore: typeof AgentStore;
  modalStore: typeof ModalStore;
  impressionTracker: TrackingType;
}

export interface INoticeState{
  activeEndModal: boolean;
  handleConfirmEndModal?: () => void;
}

export interface StartAgentProps {
  dialogueId?: string,
  queueName?: number | string,
  dialogueType?: string,
  extraParams?: Record<string, any>,
}

export interface TrackingType {
  page?: TRACKING_PAGE;
  trackingname?: string;
  operation?: TRACKING_OPERATION;
  data?: {
    button_id?: ChasingStartButtonId | ChasingEndButtonId | EndChatButtonId;
    clickable_status?: ChasingButtonClickableStatus;
    end_type?: EndChatConfirmType;
  }
}
